import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "mrd_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // Delay a bit so it doesn't compete with initial page paint
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] print:hidden"
    >
      <div className="mx-auto max-w-[1400px] px-3 sm:px-6 pb-3 sm:pb-4">
        <div className="bg-neutral-950 text-white border border-white/10 shadow-2xl rounded-sm">
          <div className="px-4 sm:px-6 py-4 sm:py-5 flex flex-col md:flex-row md:items-center gap-4">
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <div className="shrink-0 mt-0.5">
                <Cookie size={22} weight="duotone" className="text-amber-300" />
              </div>
              <div className="text-sm leading-relaxed text-neutral-200">
                <span className="font-medium text-white">We use cookies.</span>{" "}
                MyResumeDesign uses cookies and similar technologies for
                analytics, session recording, and advertising (Google Ads,
                PostHog) to improve your experience. Read our{" "}
                <Link
                  to="/privacy"
                  className="underline underline-offset-2 hover:text-white text-neutral-100"
                  data-testid="cookie-consent-privacy-link"
                >
                  Privacy Policy
                </Link>
                .
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <button
                type="button"
                onClick={() => persist("rejected")}
                data-testid="cookie-consent-reject-btn"
                className="px-4 py-2 text-xs uppercase tracking-wider border border-white/20 text-neutral-200 hover:bg-white/5 transition-colors rounded-sm"
              >
                Reject
              </button>
              <button
                type="button"
                onClick={() => persist("accepted")}
                data-testid="cookie-consent-accept-btn"
                className="px-4 py-2 text-xs uppercase tracking-wider bg-white text-neutral-950 hover:bg-neutral-200 transition-colors rounded-sm font-medium"
              >
                Accept
              </button>
              <button
                type="button"
                onClick={() => persist("dismissed")}
                aria-label="Dismiss"
                data-testid="cookie-consent-dismiss-btn"
                className="ml-1 p-1.5 text-neutral-400 hover:text-white transition-colors md:hidden"
              >
                <X size={16} weight="bold" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
